<div class="col-lg-12">
    <div id="top-text-title">
        Services
    </div>
    <div id="text-content">
        <div>
            We can offer high quality performance of the following services, described below:  
        </div>
        <div id="services-list">
            <div class="container">
                <div class="row service-container">
                    <div class="col-lg-6 col-sm-12">
                        <div class="container service-box">
                            <div class="row">
                                <div class="col-lg-2 col-sm-12 small-center-align">
                                    <div class="justify-content-center align-self-center service-container-image">
                                        <img src="../../assets/images/erp.svg" height="84" width="84">
                                    </div>
                                </div>
                                <div class="col-lg-10 col-sm-12">
                                    <div class="justify-content-center align-self-center small-center-align">
                                        <div class="service-container-content">
                                            <div class="service-container-title">
                                                Enterprise Software Development
                                            </div>
                                            <div class="service-container-text">
                                                We deliver next generation enterprise applications.<br>
                                                Our custom enterprise application development services are a great fit for companies that need modern technologies to run their businesses.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12">
                        <div class="container service-box">
                            <div class="row">
                                <div class="col-lg-2 col-sm-12  small-center-align">
                                    <div class="justify-content-center align-self-center small-center-align service-container-image">
                                        <img src="../../assets/images/web_and_mobile.svg" height="84" width="84">
                                    </div>
                                </div>
                                <div class="col-lg-10 col-sm-12">
                                    <div class="justify-content-center align-self-center small-center-align">
                                        <div class="service-container-content">
                                            <div class="service-container-title">
                                                Mobile and Web Development
                                            </div>
                                            <div class="service-container-text">
                                                Our team creates custom web and mobile-based solutions depending on the needs and preferences of the customer.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12">
                        <div class="container service-box">
                            <div class="row">
                                <div class="col-lg-2 col-sm-12 small-center-align">
                                    <div class="justify-content-center align-self-center small-center-align service-container-image">
                                        <img src="../../assets/images/api.svg" height="84" width="84">
                                    </div>
                                </div>
                                <div class="col-lg-10 col-sm-12">
                                    <div class="justify-content-center align-self-center small-center-align">
                                        <div class="service-container-content">
                                            <div class="service-container-title">
                                                API Development
                                            </div>
                                            <div class="service-container-text">
                                                We create custom dedicated APIs for all breeds of applications, integrating API systems and making connections between different services. 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12">
                        <div class="container service-box">
                            <div class="row">
                                <div class="col-lg-2 col-sm-12 small-center-align">
                                    <div class="justify-content-center align-self-center small-center-align service-container-image">
                                        <img src="../../assets/images/ux_ui.svg" height="84" width="84">
                                    </div>
                                </div>
                                <div class="col-lg-10 col-sm-12">
                                    <div class="justify-content-center align-self-center small-center-align">
                                        <div class="service-container-content">
                                            <div class="service-container-title">
                                                UX/UI Design
                                            </div>
                                            <div class="service-container-text">
                                                We design powerful digital platform-specific adaptive and responsive designs, adapted to each device type, needs, and environment with UX design services with your users in mind. 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12">
                        <div class="container service-box">
                            <div class="row">
                                <div class="col-lg-2 col-sm-12  small-center-align">
                                    <div class="justify-content-center align-self-center small-center-align service-container-image">
                                        <img src="../../assets/images/hw.svg" height="84" width="84">
                                    </div>
                                </div>
                                <div class="col-lg-10 col-sm-12">
                                    <div class="justify-content-center align-self-center small-center-align">
                                        <div class="service-container-content">
                                            <div class="service-container-title">
                                                Embedded Hardware Design
                                            </div>
                                            <div class="service-container-text">
                                                Our team is experienced with building custom embedded hardware devices with specific functions that cater to the demand for sleeker, smarter, powerful and power optimized modern-day electronics.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12">
                        <div class="container service-box">
                            <div class="row">
                                <div class="col-lg-2 col-sm-12 small-center-align">
                                    <div class="justify-content-center align-self-center small-center-align service-container-image">
                                        <img src="../../assets/images/iot.svg" height="84" width="84">
                                    </div>
                                </div>
                                <div class="col-lg-10 col-sm-12">
                                    <div class="justify-content-center align-self-center small-center-align">
                                        <div class="service-container-content">
                                            <div class="service-container-title">
                                                IoT Development
                                            </div>
                                            <div class="service-container-text">
                                                We build IoT technology for a wide spectrum of use cases and industries.<br>
                                                Creating a connected world, capturing a data from the sensors, and analyzing it, helps creating a better modern digital future.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-sm-12">
                        <div class="container service-box">
                            <div class="row">
                                <div class="col-lg-2 col-sm-12 small-center-align">
                                    <div class="justify-content-center align-self-center small-center-align service-container-image">
                                        <img src="../../assets/images/end_to_end.svg" height="84" width="84">
                                    </div>
                                </div>
                                <div class="col-lg-10 col-sm-12">
                                    <div class="justify-content-center align-self-center small-center-align">
                                        <div class="service-container-content">
                                            <div class="service-container-title">
                                                Hardware and Software End-to-End Product Development
                                            </div>
                                            <div class="service-container-text">
                                                Coming up with product ideas may be the easy part.<br>
                                                We can provide all of the development workflow, needed for turning those ideas into a profitable product.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>